"use strict";
const {
  processRegisterForProgram,
  setSpecialtyBox,
} = require("./forms/process_register_for_program");
const { show_query_form, select_speaker } = require("./events/query");
const { askQuestion } = require("./forms/process_ask_question");
const { getPrograms, toggleAttendeeDetails } = require("./events/programs");
const { getDownloadLists } = require("./events/downloads");
const { getQuery } = require("./events/query");
const { ToggleQueryTab } = require("./events/query");
const { handleAttendeeDetails } = require("./renders/show_admin_programs");

const submitRegister = document.getElementById("dtr-register");

// hook on change event to specialty box
const specialtyContainer = document.querySelector("select[name='specialty'");

// Query
const askQueryBox = document.getElementById("askQuery");
const queryLabel = document.querySelectorAll(".queryLabel");
const submitQuestion = document.getElementById("askQueryQuestion");
const queryTabs = document.querySelectorAll(".queryQuestions");

// Downloads
const downloadListButton = document.querySelectorAll("button[name='download']");

// Go Back

const goBackButton = document.getElementById("goBackButton");

const attendeeDetailsButton = document.querySelector(
  "button[name='attendeeDetails']"
);

if (typeof specialtyContainer !== "undefined" && specialtyContainer !== null) {
  specialtyContainer.addEventListener("change", (e) => setSpecialtyBox(e));
}

if (typeof submitRegister !== "undefined" && submitRegister !== null) {
  submitRegister.addEventListener("submit", (e) =>
    processRegisterForProgram(e)
  );
}

if (typeof askQueryBox !== "undefined" && askQueryBox !== null) {
  askQueryBox.addEventListener("click", show_query_form);
}

// QueRY usage
if (typeof queryLabel !== "undefined" && queryLabel !== null) {
  queryLabel.forEach((label) => {
    label.addEventListener("click", (e) => select_speaker(e));
  });
}

// submit QueRY question
if (typeof submitQuestion !== "undefined" && submitQuestion !== null) {
  submitQuestion.addEventListener("submit", askQuestion);
}

// load QueRy
if (typeof getQuery !== "undefined" && getQuery !== null) {
  document.addEventListener("DOMContentLoaded", getQuery);
}

// get Attendees
// if (typeof getPrograms !== "undefined" && getPrograms !== null) {
//   //document.addEventListener("DOMContentLoaded", () => {
//   setInterval(() => {
//     getPrograms();
//   }, 3000);
//   //});
// }

if (
  typeof attendeeDetailsButton !== "undefined" &&
  attendeeDetailsButton !== null
) {
  attendeeDetailsButton.addEventListener("click", handleAttendeeDetails);
}

//toggle attendee details container
if (typeof getPrograms !== "undefined" && getPrograms !== null) {
  if (typeof goBackButton !== "undefined" && goBackButton !== null) {
    goBackButton.addEventListener("click", toggleAttendeeDetails);
  }
}
// Download List
if (typeof downloadListButton !== "undefined" && downloadListButton !== null) {
  downloadListButton.forEach((btn) => {
    btn.addEventListener("click", getDownloadLists);
  });
}
if (typeof queryTabs !== "undefined" && queryTabs !== null) {
  queryTabs.forEach((tab) => {
    tab.addEventListener("click", ToggleQueryTab);
  });
}
